import property1 from "../images/banner/1.jpg";
import property2 from "../images/banner/2.jpg";
import property3 from "../images/banner/3.jpg";
import property4 from "../images/gallery/pic1.jpg";

export const SOLAR_BLOG_DUMMY = [];
